import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Su mentalidad no está alineada con sus objetivos', 'No tienen hábitos que las acerquen a sus metas', 'Sienten que la tecnología es complicada', 'Tienen ideas pero nunca pasan a la acción'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950" data-id="element-133">
      <div className="max-w-7xl mx-auto" data-id="element-134">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-136">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-137">
              El problema no es que no tengas potencial.
            </h2>

            <p className="text-lg text-slate-400 mb-6" data-id="element-138">
              Muchas personas quieren cambiar su vida, manifestar nuevas
              oportunidades o generar ingresos online.
            </p>

            <p className="text-lg font-medium text-slate-300 mb-6" data-id="element-139">
              Pero la mayoría se queda atrapada porque:
            </p>

            <ul className="space-y-4 mb-8" data-id="element-140">
              {painPoints.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-141">
                  <XCircle className="w-6 h-6 text-pink-400 flex-shrink-0 mt-0.5" data-id="element-142" />
                  <span className="text-slate-300 text-lg" data-id="element-143">{point}</span>
                </motion.li>)}
            </ul>

            <div className="p-6 bg-pink-500/10 rounded-2xl border border-pink-500/20" data-id="element-144">
              <p className="text-xl font-semibold text-pink-100 text-center" data-id="element-145">
                El resultado es siempre el mismo: <br data-id="element-146" />
                <span className="text-pink-400" data-id="element-147">
                  mucho deseo de cambiar, pero pocos resultados reales.
                </span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2 relative" data-id="element-148">
            <div className="absolute inset-0 bg-pink-500/20 blur-3xl rounded-full opacity-50 -z-10" data-id="element-149"></div>
            <img src="https://cdn.magicpatterns.com/uploads/midhmDuTqRLk9TpXhNauyS/task_01kktasmw0fmgbaxcy4sa27nt3_1773631548_img_0.webp" alt="Para quién es este kit" className="w-full h-auto rounded-3xl shadow-2xl border border-white/10" data-id="element-150" />
          </motion.div>
        </div>
      </div>
    </section>;
}